import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    container: {
        width:'100%',
        height: '60vh',
        marginTop: '20vh',
    },
}));

const Leadership = () => {
    const classes = useStyles();

    return (
        <Container>
            <div className={classes.container}>
                <p>Leadership</p>
            </div>
        </Container>
    )
}

export default Leadership;
